// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2dmZ8","header":"PatientQuestionnaire_header__1Ig4h","info":"PatientQuestionnaire_info__2ZcV9"};